// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"a23756bc","360":"88ea66c5"}[chunkId] + ".chunk.js";
};